// eslint-disable-next-line no-redeclare,no-unused-vars
function logout() {
    ajax({
        object: 'user',
        id: user.id,
        post: true,
        send: {
            func: 'logout'
        }
    });
    window.logoff = true;
    clearCookies();
    // localStorage.clear();
    reload();
}

//# sourceMappingURL=index.2886ca52.js.map
